<template>
  <div class="page">
    <menu-item></menu-item>

    <div class="page-content">

      <!-- Video box -->
      <div class="vid-box bg-maroon pure-g">

        <div class="vid-txt pure-u-1-1 pure-u-md-1-2">
          <h2 v-html="$lang.p_1_left_header"></h2>
          <p v-html="$lang.part_1_intro_text"></p>
        </div>

        <div class="vid-img pure-u-1-1 pure-u-md-1-2">
          <!--<div class="icon-wrapper" v-touch:tap="playVideo('273492342')">-->
          <div class="icon-wrapper" v-touch:tap="playVideo('dementia')">
            <div class="play-btn"></div>
            <div class="icon i-brain"></div>
          </div>
        </div>
      </div>

      <div class="p-section maroon">
        <div class="p-box pure-g">
          <div class="box-left pure-u-1-1 pure-u-md-1-2">
            <h2 v-html="$lang.p_1_sec_2_header"></h2>
            <p v-html="$lang.p_1_sec_2_txt"></p>
          </div>
          <div class="pure-u-1-1 pure-u-md-1-2">
            <div class="icon-header right pure-g">
              <h3 class="pure-u-2-3" v-html="$lang.p_2_sec_4_document"></h3>
              <a :href="'./static/documents/07.pdf'" class="icon p-2-sheet-0 pure-u-1-3" download="studiematerial_07" v-touch:tap="downloadBPSDDocument"></a>
            </div>
          </div>
        </div>
      </div>

      <!-- Fact box -->
      <div class="fact-box pure-g">
        <div class="fact-part left pure-u-1-1 pure-u-md-1-2">
          <div class="fact-header" v-html="$lang.fact_left_header"></div>
          <div class="fact-body">
            <!-- Buttons -->
            <div class="long-buttons">
              <div class="long-btn" v-touch:tap="openFact(0)">
                <h3>{{$lang.des_1}}</h3>
                <div class="btn white arrow empty"></div>
              </div>
              <div class="long-btn" v-touch:tap="openFact(1)">
                <h3>{{$lang.des_2}}</h3>
                <div class="btn white arrow empty"></div>
              </div>
              <div class="long-btn" v-touch:tap="openFact(2)">
                <h3>{{$lang.des_3}}</h3>
                <div class="btn white arrow empty"></div>
              </div>
              <div class="long-btn" v-touch:tap="openFact(3)">
                <h3>{{$lang.des_4}}</h3>
                <div class="btn white arrow empty"></div>
              </div>
              <div class="long-btn" v-touch:tap="openFact(4)">
                <h3>{{$lang.des_5}}</h3>
                <div class="btn white arrow empty"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="fact-part right pure-u-1-1 pure-u-md-1-2">
          <div class="fact-header" v-html="$lang.fact_right_header"></div>
          <div class="fact-body">
            <!-- Buttons -->
            <div class="long-buttons">
              <div class="long-btn" v-touch:tap="openFactGeneral(0)">
                <h3>{{$lang.gen_1}}</h3>
                <div class="btn white arrow empty"></div>
              </div>
              <div class="long-btn" v-touch:tap="openFactGeneral(1)">
                <h3>{{$lang.gen_2}}</h3>
                <div class="btn white arrow empty"></div>
              </div>
              <div class="long-btn" v-touch:tap="openFactGeneral(2)">
                <h3>{{$lang.gen_3}}</h3>
                <div class="btn white arrow empty"></div>
              </div>
              <div class="long-btn" v-touch:tap="openFactGeneral(3)">
                <h3>{{$lang.gen_4}}</h3>
                <div class="btn white arrow empty"></div>
              </div>
              <div class="long-btn" v-touch:tap="openFactGeneral(4)">
                <h3>{{$lang.gen_5}}</h3>
                <div class="btn white arrow empty"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Viewers -->
      <div class="p-section maroon no-m-down">
        <div class="p-box pure-g">
          <div class="box-left pure-u-1-1 pure-u-md-1-1" v-touch:tap="toggleViewers">
            <h2 class="toggle-ref">{{$lang.viewers}} <span :class="{'open': showViewers}"></span></h2>
          </div>
        </div>
      </div>

      <!-- Viewers box -->
      <transition name="show-view">
        <div v-show="showViewers" class="lvl-section viewers-box">
          <div class="pure-g view-container">
            <div class="view-box refs pure-u-1-1 pure-u-md-1-3">
              <h3>{{ $lang.view_header_1 }}</h3>
              <div v-for="(view, i) in viewers.facts" :key="i" class="view-body" v-html="$lang[view.key]"></div>
            </div>
            <div class="view-box refs pure-u-1-1 pure-u-md-1-3">
              <h3>{{ $lang.view_header_2 }}</h3>
              <div v-for="(view, i) in viewers.board" :key="i" class="view-body" v-html="$lang[view.key]"></div>
            </div>
            <div class="view-box refs pure-u-1-1 pure-u-md-1-3">
              <h3>{{ $lang.view_header_3 }}</h3>
              <div v-for="(view, i) in viewers.chans" :key="i" class="view-body" v-html="$lang[view.key]"></div>
            </div>
          </div>
        </div>
      </transition>

      <div class="p-section maroon">
        <div class="p-box pure-g">
          <div class="box-left pure-u-1-1 pure-u-md-1-2">
            <h2 v-html="$lang.p_1_sec_1_header"></h2>
            <p v-html="$lang.p_1_sec_1_txt"></p>
          </div>
          <div class="box-right pure-u-1-1 pure-u-md-1-2">
            <div class="icon-header right pure-g">
              <h3 class="pure-u-2-3" v-html="$lang.p_2_sec_4_document"></h3>
              <a :href="'./static/documents/10.pdf'" class="icon p-2-sheet-0 pure-u-1-3" download="studiematerial_10" v-touch:tap="downloadFallDocument"></a>
            </div>
          </div>
        </div>
      </div>

      <!-- Slider patientfall -->
      <sm-slider
        :slides="sliderData"
        :context="selfContext"
      ></sm-slider>

      <!-- To next part -->
      <div class="to-next-box p-1">
        <h4 v-html="$lang.done_part_two"></h4>
        <div class="btn-holder">
          <div class="btn white arrow" v-touch:tap="toPartOne">
            <p>{{ $lang.to_part_small }} 1</p>
          </div>
          <div class="btn white arrow" v-touch:tap="toPartResource">
            <p>{{ $lang.to_part_recourse }}</p>
          </div>
        </div>
      </div>

    </div>

    <!-- Patient cases -->
    <transition name="slideiniframe">
      <div v-if="(showResource > -1)" class="resource-iframe-wrapper popup">

        <div class="popup-close-cross-wrapper">
          <div class="icon-wrapper" v-touch:tap="closeResource">
            <div class="icon red-cross"></div>
          </div>
        </div>

        <div class="iframe-container test" id="scrollCasesBase">
          <!-- First popup -->
          <pop-one
            :popData="popData"
            :popPersons="popPersons.persons"
            :personId="showResource"
            :scrollBase="'scrollCasesBase'"
          ></pop-one>
        </div>

      </div>
    </transition>

    <!-- Faktakällor sjukdommar -->
    <transition name="slideiniframe">
      <div v-if="(showFact > -1)" class="resource-iframe-wrapper popup">

        <div class="popup-close-cross-wrapper">
          <div class="icon-wrapper" v-touch:tap="closeFact">
            <div class="icon red-cross"></div>
          </div>
        </div>

        <div class="iframe-container test">
          <!-- First popup -->
          <pop-fact
            :factData="factsData.facts[showFact]"
          ></pop-fact>
        </div>

      </div>
    </transition>

    <!-- Faktakällor General -->
    <transition name="slideiniframe">
      <div v-if="(showFactGen > -1)" class="resource-iframe-wrapper popup">

        <div class="popup-close-cross-wrapper">
          <transition name="fade">
            <div v-show="!hideCloseBtn" class="icon-wrapper" v-touch:tap="closeFactGeneral">
              <div class="icon red-cross"></div>
            </div>
          </transition>
        </div>

        <div v-if="showFactGen === 0" class="iframe-container test">
          <fact-one
            :factGenData="factGenData.facts[showFactGen]"
          ></fact-one>
        </div>

        <div v-if="showFactGen === 1" class="iframe-container test">
          <fact-two
            :factGenData="factGenData.facts[showFactGen]"
          ></fact-two>
        </div>

        <div v-if="showFactGen === 2" class="iframe-container test">
          <fact-three
            :factGenData="factGenData.facts[showFactGen]"
          ></fact-three>
        </div>

        <div v-if="showFactGen === 3" id="scrollBase" class="iframe-container test">
          <fact-four
            :factGenData="factGenData.facts[showFactGen]"
            :scrollBase="'scrollBase'"
          ></fact-four>
        </div>

        <div v-if="showFactGen === 4" class="iframe-container test">
          <fact-five
            :factGenData="factGenData.facts[showFactGen]"
          ></fact-five>
        </div>

      </div>
    </transition>

    <!-- Backdrop -->
    <transition name="fade">
      <div v-if="(showResource > -1) || (showFact !== -1) || (showFactGen !== -1)" class="iframe-backdrop"></div>
    </transition>

  </div>
</template>

<script>
import Menu from '../../../components/menu'
import SMSlider from '../../../components/small-slider'

import DataSlider from '../../../assets/data/sm_sl_1.json'
import DataPop1 from '../../../assets/data/pop_1.json'
import DataPersons from '../../../assets/data/pop_persons.json'
import DataFacts from '../../../assets/data/facts.json'
import DataFactsGen from '../../../assets/data/facts_gen.json'
import Viewers from '../../../assets/data/viewers.json'

import Pop1 from '../../../components/popups/pop-one'

import PopFact from '../../../components/popups/pop-facts'
import GenFact1 from '../../../components/facts/fact1'
import GenFact2 from '../../../components/facts/fact2'
import GenFact3 from '../../../components/facts/fact3'
import GenFact4 from '../../../components/facts/fact4'
import GenFact5 from '../../../components/facts/fact5'

export default {
  name: 'page-demens',
  data () {
    return {
      selfContext: 'dementia',
      sliderData: DataSlider.slides,
      popData: DataPop1,
      popPersons: DataPersons,
      factsData: DataFacts,
      factGenData: DataFactsGen,
      viewers: Viewers,
      doneSlides: 0,
      showResource: -1,
      showFact: -1,
      showFactGen: -1,
      hideCloseBtn: false,
      showViewers: false
    }
  },
  beforeMount () {
    this.$root.shared.currentPage = 'Dementia'
  },
  mounted () {
    // TODO: Just to force a update
    this.util.removeBodyClass('home-page')
    this.util.addBodyClass('dementia')

    let self = this
    self.$bus.$on(self.selfContext + 'SHOW.POPUP', data => {
      self.showResource = data.modal
    })

    self.$bus.$on('NEXT.FACT', data => {
      self.showResource = -1
      setTimeout(() => {
        self.showResource = data.modal
      }, 400)
    })

    self.$bus.$on('CLOSE.FACT', () => {
      self.showResource = -1
    })

    self.$bus.$on('FACT.OVERLAY.HIDE', () => {
      self.hideCloseBtn = true
    })

    self.$bus.$on('FACT.OVERLAY.SHOW', () => {
      self.hideCloseBtn = false
    })
  },
  methods: {
    toggleViewers () {
      let self = this
      return self.onToggleViewers()
    },
    onToggleViewers () {
      this.showViewers = !this.showViewers
    },
    playVideo (id) {
      let self = this
      return () => {
        self.onPlayVideo(id)
      }
    },
    onPlayVideo (id) {
      this.$bus.$emit('VIDEO.PLAYVIDEO', {videoid: id})
    },
    closeResource () {
      let self = this
      return self.onCloseResource()
    },
    onCloseResource () {
      this.showResource = -1
    },
    closeFact () {
      let self = this
      return self.onCloseFact()
    },
    onCloseFact () {
      this.showFact = -1
    },
    toPartResource () {
      let self = this
      return self.onToPartResource()
    },
    onToPartResource () {
      this.$router.push({name: 'Recourses'})
    },
    toPartOne () {
      let self = this
      return self.onToPartOne()
    },
    onToPartOne () {
      this.$router.push({name: 'Improvement'})
    },
    openFact (fact) {
      let self = this
      return () => {
        self.onOpenFact(fact)
      }
    },
    onOpenFact (fact) {
      this.showFact = fact
    },
    openFactGeneral (fact) {
      let self = this
      return () => {
        self.onOpenFactGeneral(fact)
      }
    },
    onOpenFactGeneral (fact) {
      this.showFactGen = fact
    },
    closeFactGeneral () {
      let self = this
      return self.onCloseFactGeneral()
    },
    onCloseFactGeneral () {
      this.showFactGen = -1
    },
    // downloadCaseDocument () {
    //   this.$ga.event('Downloads', 'click', 'Fallen', 9)
    // }
    downloadBPSDDocument () {
      this.$ga.event('Downloads', 'click', 'BPSD', 6)
    },
    downloadFallDocument () {
      this.$ga.event('Downloads', 'click', 'Fallbeskrivningar', 10)
    }

  },
  beforeDestroy () {
    this.util.removeBodyClass('dementia')
  },
  components: {
    'menu-item': Menu,
    'sm-slider': SMSlider,
    'pop-one': Pop1,
    'pop-fact': PopFact,
    'fact-one': GenFact1,
    'fact-two': GenFact2,
    'fact-three': GenFact3,
    'fact-four': GenFact4,
    'fact-five': GenFact5
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dementia/index.vue